<template>
    <el-card class="box-card">
        <div class="component-content">
            <el-card>
                <div slot="header" class="clearfix">
                    <component-server :serverMode="'mode_one_world_game'" @worldServer="getWorldServer" @gameServer="getGameServer"></component-server>
                    <el-button plain @click="getTableName()">加载缓存列表</el-button>
                    <span style="color: #f15e5e">(操作加载列表前请先选择游戏服/世界服)</span>
                </div>
                <el-tabs>
                    <el-tab-pane label="缓存清理">
                        <el-form label-suffix=":" label-width="80px" label-position="left">
                            <el-form-item label='选择缓存'>
                                <el-select v-model="selectedTable" clearable placeholder='请选择缓存名'>
                                    <el-option v-for="item in tableOptions" :key="item.TABLE_NAME"
                                               :label="item.TABLE_NAME"
                                               :value="item.TABLE_NAME">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label='选择类型'>
                                <el-switch v-model="selectedMode" active-text="单个缓存" inactive-text="全部" @change="modeChange"></el-switch>
                            </el-form-item>
                            <el-form-item label='输入KEY' style="width: 20%" v-if="selectedMode">
                                <el-input v-model="cacheKey" placeholder="输入KEY的值"></el-input>
                            </el-form-item>
                            <el-form-item label='操作'>
                                <el-button type="danger" @click="clearCache()">清理缓存</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="缓存容量修改">
                        <el-form label-suffix=":" label-width="80px" label-position="left">
                            <el-form-item label='选择缓存'>
                                <el-select v-model="selectTableByGetCacheVal" clearable placeholder='请选择缓存名'>
                                    <el-option v-for="item in tableOptions" :key="item.TABLE_NAME"
                                               :label="item.TABLE_NAME"
                                               :value="item.TABLE_NAME">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label='输入容量' style="width: 20%">
                                <el-input v-model="cacheCap" placeholder="请输入容量值"></el-input>
                            </el-form-item>
                            <el-form-item label='操作'>
                                <el-button type="danger" @click="setCache()">修改容量</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="查询缓存值">
                        <el-form label-suffix=":" label-width="80px" label-position="left">
                            <el-form-item label='选择缓存'>
                                <el-select v-model="selectTableByGetCacheVal" clearable placeholder='请选择缓存名'>
                                    <el-option v-for="item in tableOptions" :key="item.TABLE_NAME"
                                               :label="item.TABLE_NAME"
                                               :value="item.TABLE_NAME">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label='输入ID' style="width: 20%">
                                <el-input v-model="keyByGetCacheVal" placeholder="输入ID的值"></el-input>
                            </el-form-item>
                            <el-form-item label='操作'>
                                <el-button type="danger" @click="getCacheByVal()">查询缓存</el-button>
                            </el-form-item>
                            <el-form-item label='查询结果' style="width: 50%" v-if="cacheVal">
                                <el-input type="textarea" v-model="cacheVal"></el-input>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </div>
    </el-card>
</template>

<script>
import gameApi from '../../service/game_api'
import worldApi from '../../service/world_api'
import paginationController from '../../mixins/pagination'
import actionConfirm from '../../mixins/action_confirm'
import JsonViewer from "vue-json-viewer";
import utils from '../../lib/utils'
import {
    mapState
} from 'vuex';
import componentServer from '../../components/component_server'

export default {
    name: "cacheKit",
    data() {
        return {
            title: this.$route.meta.title,
            // 表名
            selectedTable: [],
            // 表名选择项
            tableOptions: [],
            // 类型选择
            selectedMode: false,
            cacheMode: '1',
            cacheKey: '',

            selectTableByGetCacheVal: '',
            keyByGetCacheVal: '',
            cacheVal: '',
            cacheCap:100,

            worldServer: '',
            gameServer: '',
        }
    },
    mixins: [paginationController, actionConfirm],
    watch: {},
    computed: {
        ...mapState({
            token: state => state.user.userInfo.loginToken,
        }),
    },
    created() {
    },
    components: {
        JsonViewer,
        componentServer
    },
    methods: {
        getWorldServer(val) {
            this.worldServer = val;
        },
        getGameServer(val) {
            this.gameServer = val
        },
        getTableName() {
            let self = this;
            self.tableOptions = [];
            if (!self.worldServer){
                self.$message({
                    type: 'error',
                    message: "请选择一个世界服"
                })
                return;
            }
            this.grabTables(this.worldServer,'world');

            if (!self.gameServer) {
                self.$message({
                    type: 'error',
                    message: "请选择一个游戏服"
                })
                return;
            }

            this.grabTables(this.gameServer, 'game');
        },
        // 查询配置表以及最新更新时间
        grabTables(uri, serverType) {
            let self = this;
            let cacheKitForm = {};
            if (serverType == 'game') {
                cacheKitForm = {
                    uri: uri,
                    serverType: serverType,
                }

              gameApi.getTableName(
                  {
                    token: this.token,
                    cacheKitForm: cacheKitForm
                  }
              ).then(res => {
                let resArr = res.content.tables;
                for (let resItem of resArr) {
                  self.tableOptions.push({
                    TABLE_NAME: utils.tableNameTransfer(resItem.TABLE_NAME),
                    URI: uri,
                    SERVER_TYPE: serverType
                  });
                }
              })
            } else {
                cacheKitForm = {
                    worldUri: uri,
                    serverType: serverType,
                }
              worldApi.getTableName(
                  {
                    token: this.token,
                    cacheKitForm: cacheKitForm
                  }
              ).then(res => {
                let resArr = res.content.tables;
                for (let resItem of resArr) {
                  self.tableOptions.push({
                    TABLE_NAME: utils.tableNameTransfer(resItem.TABLE_NAME),
                    URI: uri,
                    SERVER_TYPE: serverType
                  });
                }
              })
            }
        },
        getCacheByVal() {
            console.log(this.selectTableByGetCacheVal)
            let self = this;
            let tarVal;
            this.tableOptions.forEach(item => {
                if (this.selectTableByGetCacheVal === item.TABLE_NAME) {
                    tarVal = item;
                }
            })
            console.log(tarVal)

            let cacheKitForm = {};
            if (tarVal.SERVER_TYPE == 'game') {
                cacheKitForm = {
                    uri: tarVal.URI,
                    serverType: tarVal.SERVER_TYPE,
                    tableName: tarVal.TABLE_NAME,
                    key: this.keyByGetCacheVal
                }

              gameApi.getCacheValue({
                token: this.token,
                cacheKitForm: cacheKitForm
              }).then(res => {
                self.cacheVal = res.content.json;
              })

            } else {
                cacheKitForm = {
                    worldUri: tarVal.URI,
                    serverType: tarVal.SERVER_TYPE,
                    tableName: tarVal.TABLE_NAME,
                    key: this.keyByGetCacheVal
                }

              worldApi.getCacheValue({
                token: this.token,
                cacheKitForm: cacheKitForm
              }).then(res => {
                self.cacheVal = res.content.json;
              })
            }
        },
        clearCache() {
            let self = this;
            if (this.selectedTable === '') {
                this.$message.error("至少选择一个缓存名")
                return;
            }

            let tarVal;
            this.tableOptions.forEach(item => {
                if (this.selectedTable === item.TABLE_NAME) {
                    tarVal = item;
                }
            })

            let cacheKitForm = {};
            if (tarVal.SERVER_TYPE == 'game') {
                cacheKitForm = {
                    uri: tarVal.URI,
                    serverType: tarVal.SERVER_TYPE,
                    tableName: tarVal.TABLE_NAME,
                    mode: self.cacheMode,
                    key: self.cacheKey
                }

              gameApi.clearSettingCache({
                token: this.token,
                cacheKitForm: cacheKitForm
              }).then(res => {
                console.log(res)
                this.$message.success("游戏服重置成功")
              })
            } else {
                cacheKitForm = {
                    worldUri: tarVal.URI,
                    serverType: tarVal.SERVER_TYPE,
                    tableName: tarVal.TABLE_NAME,
                    mode: self.cacheMode,
                    key: self.cacheKey
                }

              worldApi.clearSettingCache({
                token: this.token,
                cacheKitForm: cacheKitForm
              }).then(res => {
                console.log(res)
                this.$message.success("战区缓存重置成功")
              })
            }
        },
        setCache() {
            let self = this;
            if (this.selectTableByGetCacheVal === '') {
                this.$message.error("至少选择一个缓存名")
                return;
            }

            let tarVal;
            this.tableOptions.forEach(item => {
                if (this.selectTableByGetCacheVal === item.TABLE_NAME) {
                    tarVal = item;
                }
            })

            let cacheKitForm = {};
            if (tarVal.SERVER_TYPE == 'game') {
                cacheKitForm = {
                    uri: tarVal.URI,
                    serverType: tarVal.SERVER_TYPE,
                    tableName: tarVal.TABLE_NAME,
                    mode: '100',
                    key:self.cacheCap
                }
              gameApi.clearSettingCache({
                token: this.token,
                cacheKitForm: cacheKitForm
              }).then(res => {
                this.$message.success("重置成功")
              })

            } else {
                cacheKitForm = {
                    worldUri: tarVal.URI,
                    serverType: tarVal.SERVER_TYPE,
                    tableName: tarVal.TABLE_NAME,
                    mode: '100',
                    key:self.cacheCap
                }

              worldApi.clearSettingCache({
                token: this.token,
                cacheKitForm: cacheKitForm
              }).then(res => {
                this.$message.success("重置成功")
              })
            }
        },
        modeChange() {
            let self = this;
            if (self.selectedMode == true) {
                self.cacheMode = '0';
                self.cacheKey = '';
            } else {
                self.cacheMode = '1';
                self.cacheKey = '';
            }
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/test_tools/cache_kit.vue